import store from '@/store'

// Deny access to pages which require logged in if logged out
export function authGuard(to, from, next) {
  const requiresAuth = to.matched.some((record) => {
    return record.meta.requiresAuth
  })
  const userPermission = to.matched.some((role) => {
    return role.meta.userPermission
  })

  if(requiresAuth && !store.getters.getIsAuthenticated) {
    return next({name: 'Login'})
  }

  if(userPermission && store.getters.authUser.roles[0].name === 'nurse') {
    return next({name: 'all-patients'})
  }

  next()
}

// Deny access to pages which require logged out if logged in
export function loginGuard(to, from, next) {
  const requiresLoggedOut = to.matched.some((record) => {
    return record.meta.requiresLoggedOut
  })

  if(requiresLoggedOut && store.getters.getIsAuthenticated) {
    return next({name: 'Overview'})
  }

  next()
}

// Deny access to pages which require a license if not licensed
export function licenseGuard(to, from, next) {
  if (store.getters.isLicensed) {
    next();
  } else {
    next({name: 'License Expired'});
  }
}



// WEBPACK FOOTER //
// ./src/router/guards.js